import {Button} from '../../button/button';
import {Illustration} from '../../illustrations/illustration';
import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

type Props = {
    illustrationSrc: string;
    title: string;
    subtitle: string;
    cta: {
        label: string;
        onClick: () => void;
    };
};

export function NeedsUseEmptyState(props: Props) {
    return (
        <div className='flex flex-dir-col align-center px-32 gap-12'>
            <Stack spacing={12}>
                <Illustration src={props.illustrationSrc} height={90} />
                <Stack spacing={0} alignItems='center'>
                    <Body color='light' size='small'>
                        {props.title}
                    </Body>
                    <Body color='light' size='small'>
                        {props.subtitle}
                    </Body>
                </Stack>
            </Stack>
            <Button variant='text-primary' size='small' onClick={props.cta.onClick}>
                {props.cta.label}
            </Button>
        </div>
    );
}
